var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1584 31L1584 59",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1584.5,
    cy: 26.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.99 26.1898C1579.99 22.2835 1583.29 19.1168 1587.36 19.1168C1587.94 19.1168 1588.51 19.1841 1589.06 19.3076C1587.74 18.4804 1586.19 18 1584.52 18C1579.81 18 1576 21.8056 1576 26.5C1576 31.1944 1579.81 35 1584.52 35C1586.81 35 1588.89 34.0929 1590.43 32.6205C1589.49 33.0317 1588.45 33.2628 1587.36 33.2628C1583.29 33.2628 1579.99 30.0961 1579.99 26.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.4 25.6003L1593.37 23.1461L1591.54 24.7189L1589.3 24.0564L1590.11 26.3367L1588.77 28.3813L1591.1 28.2179L1592.5 30.144L1593.13 27.7627L1595.34 26.9085L1593.4 25.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch7);
export default __webpack_public_path__ + "static/media/church_7.1f45a8e35f5aef4067e7b344cd9a3263.svg";
export { ForwardRef as ReactComponent };